import { Body, Square } from "./Body.js";
import { requestTalk } from "./TalkManager.js";
import { Speech } from "./TalkPanel.js";
import { Vector } from "./Vector.js";

export class SquareMob extends Square {
    HP: number = 1;
    ATK: number = 1;
    dead: boolean = false;
    constructor() {
        super();
    }

    get isDead(): boolean {
        return this.dead;
    }

    repels(body: Body): void {
        if (body instanceof SquareMob && this.isTouchingWith(body)) {
            this.attack(body);
        }
        super.repels(body);
    }

    setHP(HP: number) {
        this.HP = Math.max(HP, 0);
    }

    setATK(ATK: number) {
        this.ATK = Math.max(ATK, 0);
    }
    damage(damage: number) {
        if (this.dead) {
            return;
        }
        this.setHP(this.HP - damage);
        if (this.HP == 0) {
            this.die();
        }
    }
    attack(body: SquareMob) {
        body.damage(this.ATK);
    }

    die() {
        this.dead = true;
    }
    move(position: Vector): void {
        if (this.dead) {
            return;
        }
        super.move(position);
    }
}

export class Player extends SquareMob {
    constructor() {
        super();
        super.setSize(new Vector(100, 100));
        this.element.classList.add("player");
        this.setHP(Infinity);
        this.setATK(Infinity);
    }
}

export class CheckPoint extends Square {
    booted: boolean = false;
    // respawnCount: number = 0;
    constructor() {
        super();
        super.setSize(new Vector(100, 100));
        this.element.classList.add("checkPoint");
        this.touchable = false;
        this.movable = false;
    }

    set s$booted(booted: boolean) {
        if (this.booted == booted) {
            return;
        }
        this.booted = booted;
        if (booted) {
            this.element.classList.add("bootedCheckPoint");
        } else {
            this.element.classList.remove("bootedCheckPoint");
        }
    }
}

export class Goal extends Square {
    constructor() {
        super();
        super.setSize(new Vector(150, 150));
        this.element.classList.add("goal");
        this.touchable = false;
        this.movable = false;
    }
}

export class Signboard extends Square {
    private talk: Speech[] = [];
    constructor(talk: Speech[] = []) {
        super();
        super.setSize(new Vector(100, 100));
        this.element.classList.add("signBoard");
        this.touchable = false;
        this.movable = false;
        this.s$talk = talk;
    }

    set s$talk(talk: Speech[]) {
        this.talk = talk;
    }

    requestRead() {
        requestTalk(this.talk);
    }
}
